import GroupListItem from "../react_components/group/group_list_item";
import ResponsivePageAdContainer from "../react_components/ads/responsive_page_ad_container";

export const GroupsComponents = { GroupListItem, ResponsivePageAdContainer };
